require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-new-branch-hours-in-effect.json") })
        }
      }, "path---es-articles-new-branch-hours-in-effect");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-new-branch-hours-in-effect!./.cache/json/es-articles-new-branch-hours-in-effect.json
// module id = 2221
// module chunks = 231608221292675